<app-breadcrumb [title]="'Registrarse'" [breadcrumb]="'Registrarse'"></app-breadcrumb>
<!-- section start -->
<section class="login-page section-b-space">
  <div class="container">
    <div class="row">
      <form [formGroup]="registrarUsuarioForm" autocomplete="off">
        <!-- <div class="row mb-3 d-flex align-items-center">
          <div class="col-md-3">
            <h4><strong>¿Ya eres nuestro cliente?</strong></h4>
          </div>
          <div class="col-md-1">
            <label>
              <input type="radio" formControlName="YaEsCliente" [value]="true" />
              Si
            </label>
          </div>
          <div class="col-md-1">
            <label>
              <input type="radio" formControlName="YaEsCliente" [value]="false" />
              No
            </label>
          </div>
        </div>
        <div class="row d-flex justify-content-center">
          <div class="row col-8 d-flex justify-content-center mb-3"
            *ngIf="registrarUsuarioForm.get('YaEsCliente').value === true">
            <div class="col-md-5">
              <i class="fa fa-phone"></i>&nbsp;
              <label for="nombre">Teléfono GIGMAX</label>
              <input (input)="soloNumeros($event)" formControlName="phoneNumber" class="form-control" id="nombre" maxlength="10"
                required />
            </div>
            <div class="col-md-5">
              <i class="fa fa-phone"></i>&nbsp;              <label for="nombre">N° de Cuenta</label>
              <input formControlName="NumeroCliente" class="form-control" id="nombre" required />
            </div>
          </div>
        </div> -->
        <div class="row">
          <div class="col-md-4">
            <i class="fa fa-id-card"></i>&nbsp;
            <label for="nombre">Nombre</label>
            <input formControlName="nombre" class="form-control" id="nombre" required />
            <span class="text-danger" *ngIf="
                registrarUsuarioForm.get('nombre').touched &&
                registrarUsuarioForm.get('nombre').errors?.required
              ">
              Campo requerido
            </span>
          </div>
          <div class="col-md-4">
            <i class="fa fa-id-badge"></i>&nbsp;
            <label for="apellidoPaterno">Apellido Paterno</label>
            <input formControlName="apellidoPaterno" class="form-control" id="apellidoPaterno" required />
            <span class="text-danger" *ngIf="
                registrarUsuarioForm.get('apellidoPaterno').touched &&
                registrarUsuarioForm.get('apellidoPaterno').errors?.required
              ">
              Campo requerido
            </span>
          </div>
          <div class="col-md-4">
            <i class="fa fa-id-badge"></i>&nbsp;
            <label for="apellidoMaterno">Apellido Materno</label>
            <input formControlName="apellidoMaterno" class="form-control" id="apellidoMaterno" required />
            <span class="text-danger" *ngIf="
                registrarUsuarioForm.get('apellidoMaterno').touched &&
                registrarUsuarioForm.get('apellidoMaterno').errors?.required
              ">
              Campo requerido
            </span>
          </div>
          <div class="col-md-4 mt-3">
            <i class="fa fa-id-badge"></i>&nbsp;
            <label for="fechaNacimiento">Fecha de nacimiento <span class="text-danger">* </span><span
                style="font-style: italic; color: gray">Debes ser mayor de edad para registrarte</span></label>
            <dx-date-box class="form-control" [(value)]="fechaNacimiento" [min]="min" type="date" [max]="max"
              invalidDateMessage="Ingrese una fecha válida">
              <dx-validator>
                <dxi-validation-rule type="required" message="Campo requerido"></dxi-validation-rule>
              </dx-validator>
            </dx-date-box>
            <!-- <span class="text-danger"
                              *ngIf="(registrarUsuarioForm.get('fechaNacimiento').touched) && registrarUsuarioForm.get('fechaNacimiento').hasError('required')">
                            Campo requerido
                        </span> -->
          </div>
          <div class="col-md-4 mt-3">
            <i class="fa fa-envelope"></i>&nbsp;
            <label id="correo">Correo</label>
            <input formControlName="correo" class="form-control" id="correo" autocomplete="username"
              required="required" />
            <span class="text-danger" *ngIf="
                registrarUsuarioForm.get('correo').touched &&
                registrarUsuarioForm.get('correo').errors?.required
              ">
              Campo requerido
            </span>
            <span class="text-danger" *ngIf="
                registrarUsuarioForm.get('correo').touched &&
                registrarUsuarioForm.get('correo').hasError('pattern')
              ">
              Ingrese un correo válido
            </span>
          </div>
          <div class="col-md-4 mt-3">
            <i class="fa fa-phone"></i>&nbsp;
            <label for="nombre">Teléfono</label>
            <input formControlName="Telefono" class="form-control" id="nombre" (input)="soloNumeros2($event)"
            maxlength="10" required />
          </div>
          <div class="col-md-6 mt-3" formGroupName="passwordGroup">
            <i class="fa fa-key"></i>&nbsp;
            <label id="pws1">Contraseña</label>
            <div class="cont-icon-eye">
              <input (keyup)="onPasswordInput($event)" [type]="hidePass ? 'password' : 'text'"
                autocomplete="new-password" style="width: 100% !important" maxlength="16"
                pattern="^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z]).{6,}$" formControlName="password"
                required="required" class="form-control" />
              <span class="toggle-password" [ngClass]="{
                  'show-password': !hidePass,
                  'hide-password': hidePass
                }" (click)="togglePassword('password')"></span>
            </div>
            <!-- <span class="text-danger" *ngIf="registrarUsuarioForm.get('passwordGroup.password').invalid || registrarUsuarioForm.get('passwordGroup.password').touched ">
                            {{ mensajes['password'] }}
                            </span> -->
            <!-- <p class="mb-0"> <i class="fa fa-check-circle" [ngClass]="{'checked': minCaracteres && maxCaracteres}" aria-hidden="true"></i> La contraseña debe contener más de 6 caracteres y menos de 16.</p>
                            <p class="mb-0"> <i class="fa fa-check-circle" [ngClass]="{'checked': hasNumber && hasMayus && hasMinus && espCaracter}" aria-hidden="true"></i> La contraseña debe tener al menos un dígito, una minúscula, una mayúscula y un caracter no alfanumérico.</p> -->

            <p class="mb-0">
              <i class="fa fa-check-circle" [ngClass]="{ checked: minCaracteres && maxCaracteres }"
                aria-hidden="true"></i>
              La contraseña debe tener más de 6 caracteres y menos de 16.
            </p>
            <p class="mb-0">
              <i class="fa fa-check-circle" [ngClass]="{ checked: hasMayus && hasMinus }" aria-hidden="true"></i>
              Al menos una mayúscula y minúsculas.
            </p>
            <p class="mb-0">
              <i class="fa fa-check-circle" [ngClass]="{ checked: espCaracter }" aria-hidden="true"></i>
              Un caracter no alfanumérico (ejemplo: #?!&).
            </p>
            <p class="mb-0">
              <i class="fa fa-check-circle" [ngClass]="{ checked: hasNumber }" aria-hidden="true"></i>
              Un número.
            </p>

            <!-- <p class="mb-0"> <i class="fa fa-check-circle" [ngClass]="{'checked': hasNumber}" aria-hidden="true"></i> Al menos un número.</p>
                            <p class="mb-0"> <i class="fa fa-check-circle" [ngClass]="{'checked': hasMayus}" aria-hidden="true"></i> Al menos una mayúscula</p>
                            <p class="mb-0"> <i class="fa fa-check-circle" [ngClass]="{'checked': hasMinus}" aria-hidden="true"></i> Al menos una minúscula</p>
                            <p class="mb-0"> <i class="fa fa-check-circle" [ngClass]="{'checked': espCaracter}" aria-hidden="true"></i> Al menos un caracter especial</p>
                            <p class="mb-0"> <i class="fa fa-check-circle" [ngClass]="{'checked': minCaracteres}" aria-hidden="true"></i> Al menos 6 caracteres</p>
                            <p class="mb-0"> <i class="fa fa-check-circle" [ngClass]="{'checked': maxCaracteres}" aria-hidden="true"></i> No más de 16 caracteres</p> -->
          </div>
          <div class="col-md-6 mt-3">
            <div formGroupName="passwordGroup">
              <i class="fa fa-key"></i>&nbsp;
              <label id="matLabel">Confirmar Contraseña</label>
              <div class="cont-icon-eye">
                <input matInput [type]="hideConfirm ? 'password' : 'text'" formControlName="confirmPassword" maxlength="16"
                  autocomplete="new-password" required="required" class="form-control input-danger" />
                <span class="toggle-password" [ngClass]="{
                    'show-password': !hideConfirm,
                    'hide-password': hideConfirm
                  }" (click)="togglePassword('confirm')"></span>
              </div>
              <span class="text-danger" *ngIf="
                  registrarUsuarioForm.get('passwordGroup').hasError('match')
                ">
                Las contraseñas no coinciden.
              </span>
            </div>
          </div>
          <!--<div class="kt-portlet__foot  mt-3">
                        <div class="kt-form__actions kt-form__actions">
                            <button class="btn btn-primary buttonSubmit" id="guardarBoton" (click)="onSubmit()" [disabled]=" loading">
                                <dx-load-indicator *ngIf="loading"
                                id="small-indicator"
                                height="20"
                                width="20"
                                ></dx-load-indicator>
                                <span>{{loading ? "Guardando" : "Guardar"}}</span>
                            </button>&nbsp;
                            <button  class="btn btn-danger" (click)="onCancel()" [disabled]="loading"><i class="fa fa-times"></i>&nbsp;Cancelar</button>
                        </div>
                    </div>-->
          <div class="d-flex justify-content-center mt-3">
            <button class="btn btn-solid mt-2" (click)="registrarUsuario()">
              Registrarse
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
  <!-- <div> -->
  <div *ngIf="modalCodigo === true">
    <app-modal-codigo #modalCodigo></app-modal-codigo>
  </div>
</section>